import classNames from "classnames";
import styles from "../css/ContainerNavigationView.module.css";
import IconButton from "./IconButton";

interface ContainerNavigationViewProps {
  open: boolean;
  title: string;
  leftButtonText?: string;
  leftImageButtonImage?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  rightTextButtonText?: string;
  rightTextButtonColor?: string;
  onClickLeftImageButton?: () => void;
  onClickRightTextButton?: () => void;
}

export default function ContainerNavigationView(
  props: ContainerNavigationViewProps
) {
  if (!props.open) {
    return null;
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.leftButtonContainer}>
          {props.leftButtonText !== undefined && (
            <span className={styles.textButton}>{props.leftButtonText}</span>
          )}
          {props.leftImageButtonImage !== undefined && (
            <IconButton
              showing={true}
              icon={props.leftImageButtonImage}
              onClick={props.onClickLeftImageButton}
              size="16px"
            />
          )}
        </div>
        <div className={styles.centerContainer}>
          <span className={styles.titleText}>{props.title}</span>
        </div>
        <div className={styles.rightButtonContainer}>
          {props.rightTextButtonText !== undefined && (
            <span
              className={styles.textButton}
              style={{ color: props.rightTextButtonColor ?? undefined }}
              onClick={props.onClickRightTextButton}
            >
              {props.rightTextButtonText}
            </span>
          )}
        </div>
      </div>
    </>
  );
}
